import React from "react";
import { MAX_MONSTERS } from "../../helpers/helpers";

type LegendProps = {
  isDarkMode: boolean;
};

export const Legend: React.FC<LegendProps> = ({ isDarkMode }) => (
  <div
    className={`justify-left flex h-full w-full flex-col items-center ${isDarkMode ? "bg-darkblack" : "bg-green"}`}
  >
    <div
      className={`mt-2 flex flex-col items-start justify-start rounded-lg border-2  ${isDarkMode ? "border-darkgreen bg-darkblue text-white [box-shadow:inset_0_-1px_#37b764]" : "border-brown bg-white [box-shadow:inset_0_-2px_#342e2e]"} w-[21.5rem]`}
    >
      <div className="flex w-full flex-col items-start justify-center">
        <h2 className="mb-1 mt-1 p-1 text-lg font-semibold">Stat Bar</h2>
        <hr className={`w-full border-t-2 ${isDarkMode ? "border-darkgreen" : "border-brown"}`} />
        <ul className="w-full p-2 text-sm">
          <li className="mb-2 flex items-center ">
            <img
              src={isDarkMode ? "/imgs/treasureDark.svg" : "/imgs/treasure.svg"}
              alt=""
              className="h-5 w-5"
            />
            <div className="ml-[.02rem] mr-1">•</div>
            <p>Total ETH rewards</p>
          </li>
          <li className="mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/walletDark.svg" : "/imgs/wallet.svg"}
              alt=""
              className="ml-[.05rem] h-4 w-4"
            />
            <div className="ml-[.2rem] mr-1">•</div>
            <p>Wallet ETH balance</p>
          </li>
          <li className="mb-2 flex items-center ">
            <img
              src={isDarkMode ? "/imgs/coin-bagDark.svg" : "/imgs/coin-bag.svg"}
              alt=""
              className="h-5 w-5"
            />
            <div className="ml-[.02rem] mr-1">•</div>
            <p>Wallet pGold balance</p>
          </li>
          <li className="mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/piggy-bankDark.svg" : "/imgs/piggy-bank.svg"}
              alt=""
              className="h-4 w-4"
            />
            <div className="ml-1 mr-1">•</div>
            <p>Total score</p>
          </li>
          <li className="mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/carrotDark.svg" : "/imgs/carrot.svg"}
              alt=""
              className="h-4 w-4"
            />
            <div className="ml-1 mr-1">•</div>
            <p>Total carrot count</p>
          </li>
          <li className="mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/frogDark.svg" : "/imgs/frog.svg"}
              alt=""
              className="h-4 w-4"
            />
            <div className="ml-1 mr-1">•</div>
            <p>Wallet FP balance</p>
          </li>
          <li className="mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/frogDark.svg" : "/imgs/frog.svg"}
              alt=""
              className="h-4 w-4"
            />
            <div className="ml-1 mr-1">•</div>
            <p>Total FP claimable / Total fp staked</p>
          </li>
          <li className="mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/pokeballDark.svg" : "/imgs/pokeball.svg"}
              alt=""
              className="mt-[0.05rem] h-5 w-5"
            />
            <div className="mr-1">•</div>
            <p>Total monsters caught</p>
          </li>
          <li className="mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/starDark.svg" : "/imgs/star.svg"}
              alt=""
              className="h-4 w-4"
            />
            <div className="ml-1 mr-1">•</div>
            <p>Total stars (hibernations | kills)</p>
          </li>
          <li className="mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/gasDark.svg" : "/imgs/gas.svg"}
              alt=""
              className="h-4 w-4"
            />
            <div className="ml-1 mr-1">•</div>
            <p>Current gas tick</p>
          </li>
          <li className="mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/frogDark.svg" : "/imgs/frog.svg"}
              alt=""
              className="h-4 w-4"
            />
            <div className="ml-1 mr-1">•</div>
            <p>Current FP price</p>
          </li>
        </ul>
      </div>
    </div>
    <div
      className={`mt-4 flex flex-col items-start justify-start rounded-lg border-2  ${isDarkMode ? "border-darkgreen bg-darkblue text-white [box-shadow:inset_0_-1px_#37b764]" : "border-brown bg-white [box-shadow:inset_0_-2px_#342e2e]"}  w-[21.5rem]`}
    >
      <div className="relative flex w-full flex-col items-start justify-center">
        <h2 className="mb-1 mt-1 p-1 text-lg font-semibold">Timers View</h2>
        <hr className={`w-full border-t-2 ${isDarkMode ? "border-darkgreen" : "border-brown"}`} />
        <ul className="ml-[.15rem] w-full p-2 text-sm">
          <li className="mb-2 flex items-center ">
            <span
              className={`absolute -translate-x-[28%] -translate-y-[5%] transform rounded-full border ${isDarkMode ? "border-darkgreen bg-darkblue ring-darkgreen [box-shadow:inset_0_-2px_#37b764]" : "border-brown bg-green ring-brown [box-shadow:inset_0_-2px_#342e2e]"} px-[.25rem] py-[.05rem] text-xs ring-1 ring-inset`}
            >
              lv. 4
            </span>
            <div className="ml-6 mr-1">•</div>
            <p>Pet level</p>
          </li>
          <li className="mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/piggy-bankDark.svg" : "/imgs/piggy-bank.svg"}
              alt=""
              className="h-5 w-5"
            />
            <div className="ml-1 mr-1">•</div>
            <p>Pet score</p>
          </li>
          <li className="mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/slotDark.svg" : "/imgs/slot.svg"}
              alt=""
              className="ml-[.25rem] h-4 w-4"
            />
            <div className="ml-1 mr-1">•</div>
            <p>Points to next gacha</p>
          </li>
          <li className="mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/appleDark.svg" : "/imgs/apple.svg"}
              alt=""
              className="ml-[.15rem] h-4 w-4"
            />
            <div className="ml-[.35rem] mr-1"> •</div>
            <p>Time until pet starves</p>
          </li>
          <li className="mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/swordDark.svg" : "/imgs/sword.svg"}
              alt=""
              className="mt-[0.05rem] h-5 w-5 scale-x-[-1] transform"
            />
            <div className="ml-1 mr-1">•</div>
            <p>Time until next bonk</p>
          </li>
          <li className="mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/wheelspinDark.svg" : "/imgs/wheelspin.svg"}
              alt=""
              className="h-5 w-5"
            />
            <div className="ml-1 mr-1">•</div>
            <p>Time until next wheel spin</p>
          </li>
          <li className="mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/shield-solidDark.svg" : "/imgs/shield-solid.svg"}
              alt=""
              className="ml-[.15rem] h-4 w-4"
            />
            <div className="ml-[.35rem] mr-1"> •</div>
            <p>Time until shield expires</p>
          </li>
          <li className="mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/weightDark.svg" : "/imgs/weight.svg"}
              alt=""
              className="ml-[.15rem] h-4 w-4"
            />
            <div className="ml-[.35rem] mr-1"> •</div>
            <p>Time until training completes</p>
          </li>
        </ul>
      </div>
    </div>
    <div
      className={`mt-4 flex flex-col items-start justify-start rounded-lg border-2 ${isDarkMode ? "border-darkgreen bg-darkblue text-white [box-shadow:inset_0_-1px_#37b764]" : "border-brown bg-white [box-shadow:inset_0_-2px_#342e2e]"} w-[21.5rem]`}
    >
      <div className="relative flex w-full flex-col items-start justify-center">
        <h2 className="mb-1 mt-1 p-1 text-lg font-semibold">Stats View</h2>
        <hr className={`w-full border-t-2 ${isDarkMode ? "border-darkgreen" : "border-brown"}`} />
        <ul className="w-full p-3 text-sm">
          <li className="mb-2 flex items-center ">
            <span
              className={`absolute -translate-x-[30%] -translate-y-[5%] transform rounded-full border px-[.25rem] py-[.05rem] text-xs ring-1 ring-inset ${isDarkMode ? "border-darkgreen bg-darkblue ring-darkgreen [box-shadow:inset_0_-1px_#37b764]" : "border-brown bg-green ring-brown [box-shadow:inset_0_-2px_#342e2e]"}`}
            >
              lv. 4
            </span>
            <div className="ml-6 mr-1">•</div>
            <p>Pet level</p>
          </li>
          <li className="mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/piggy-bankDark.svg" : "/imgs/piggy-bank.svg"}
              alt=""
              className="h-5 w-5"
            />
            <div className="ml-1 mr-1">•</div>
            <p>Pet score daily % change</p>
          </li>
          <li className="mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/slotDark.svg" : "/imgs/slot.svg"}
              alt=""
              className="ml-[.25rem] h-4 w-4"
            />
            <div className="ml-1 mr-1">•</div>
            <p>Gacha efficiency, avg expected of +2.5</p>
          </li>
          <li className="mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/ethereumDark.svg" : "/imgs/ethereum.svg"}
              alt=""
              className="ml-[.15rem] h-4 w-4"
            />
            <div className="ml-[.35rem] mr-1"> •</div>
            <p>Pet ETH rewards</p>
          </li>
          <li className="mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/hourglassDark.svg" : "/imgs/hourglass.svg"}
              alt=""
              className="ml-[.05rem] mr-[.05rem] h-4 w-4"
            />
            <div className="age1 ml-[.4rem] mr-1">•</div>
            <p>Pet age in days alive</p>
          </li>
          <li className="mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/carrotDark.svg" : "/imgs/carrot.svg"}
              alt=""
              className="ml-[.05rem] h-4 w-4"
            />
            <div className="ml-[.45rem] mr-1"> •</div>
            <p>Pet carrot count</p>
          </li>
          <li className="mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/passBadgeDark.png" : "/imgs/passBadge.png"}
              alt=""
              className="ml-[.05rem] h-4 w-4"
            />
            <div className="ml-[.45rem] mr-1">•</div>
            <p>FP Monthly Pass</p>
          </li>
          <li className="mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/frogDark.svg" : "/imgs/frog.svg"}
              alt=""
              className="ml-[.05rem] h-4 w-4"
            />
            <div className="ml-[.45rem] mr-1">•</div>
            <p>FP claimable / FP staked</p>
          </li>
          <li className="mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/boltDark.svg" : "/imgs/bolt.svg"}
              alt=""
              className="ml-[.1rem] mt-[0.05rem] h-4 w-4"
            />
            <div className="ml-[.4rem] mr-1">•</div>
            <p>Bonk energy bar</p>
          </li>
          <li className="mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/starDark.svg" : "/imgs/star.svg"}
              alt=""
              className="ml-[.05rem] h-4 w-4"
            />
            <div className="ml-[.45rem] mr-1">•</div>
            <p>Pet stars (hibernations | kills)</p>
          </li>
          <li className="mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/swordDark.svg" : "/imgs/sword.svg"}
              alt=""
              className="mt-[0.05rem] h-5 w-5 scale-x-[-1] transform"
            />
            <div className="ml-[.26rem] mr-1">•</div>
            <p>Pet attack points</p>
          </li>
          <li className="mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/shieldDark.svg" : "/imgs/shield.svg"}
              alt=""
              className="mt-[0.05rem] h-4 w-4"
            />
            <div className="ml-[.5rem] mr-1">•</div>
            <p>Pet defense points</p>
          </li>
          <li className="mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/trophyDark.svg" : "/imgs/trophy.svg"}
              alt=""
              className="mt-[0.05rem] h-4 w-4"
            />
            <div className="ml-[.5rem] mr-1">•</div>
            <p>Pet training wins | Pet total wins</p>
          </li>
          <li className="mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/pokeballDark.svg" : "/imgs/pokeball.svg"}
              alt=""
              className="mt-[0.05rem] h-5 w-5"
            />
            <div className="ml-[.26rem] mr-1">•</div>
            <p>Total monsters caught out of {MAX_MONSTERS}</p>
          </li>
          <li className="mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/shield-solidDark.svg" : "/imgs/shield-solid.svg"}
              alt=""
              className="ml-[.1rem] mt-[0.05rem] h-4 w-4"
            />
            <div className="ml-[.4rem] mr-1">•</div>
            <p>Shield owned count</p>
          </li>
          <li className="relative mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/slotDark.svg" : "/imgs/slot.svg"}
              alt=""
              className="ml-[.15rem] h-4 w-4"
            />
            <span
              className={`absolute -translate-y-[45%] translate-x-[50%] transform rounded-full border px-[.35rem] py-[.05rem] text-xs ring-1 ring-inset ${isDarkMode ? "border-darkgreen bg-darkblue ring-darkgreen [box-shadow:inset_0_-2px_#37b764]" : "border-brown bg-green ring-brown [box-shadow:inset_0_-2px_#342e2e]"}`}
            >
              1
            </span>
            <div className="ml-[.35rem] mr-1">•</div>
            <p>Pending gacha rolls</p>
          </li>
          <li className="relative mb-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/trophyDark.svg" : "/imgs/trophy.svg"}
              alt=""
              className="ml-[.05rem] h-4 w-4"
            />
            <span
              className={`absolute -translate-y-[45%] translate-x-[50%] transform rounded-full border px-[.35rem] py-[.05rem] text-xs ring-1 ring-inset ${isDarkMode ? "border-darkgreen bg-darkblue ring-darkgreen [box-shadow:inset_0_-2px_#37b764]" : "border-brown bg-green ring-brown [box-shadow:inset_0_-2px_#342e2e]"}`}
            >
              1
            </span>
            <div className="ml-[.43rem] mr-1">•</div>
            <p>Available wins to use on training</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
);
